import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import SaveFile from '../../services/saveFile';
import Cookies from 'universal-cookie';
import moment from 'moment';
import { Font } from '@react-pdf/renderer'
import bold from "./fonts/Montserrat-Bold.ttf"
import regular from "./fonts/Montserrat-Regular.ttf"
import italic from "./fonts/Montserrat-Italic.ttf"
import Utils from "../utils"

import getPdf from '../../services/getPdf';
import mergePdf from '../../services/mergePdf';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    fontFamily: 'regular',
    paddingBottom: 90
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  table: { paddingRight: 10, paddingLeft: 10, display: "table", width: "auto", borderStyle: "solid", borderWidth: 1, borderRightWidth: 0, borderBottomWidth: 0 }, 
  tableRow: { margin: "auto", flexDirection: "row" }, 
  tableCol: { width: "25%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 1 }, 
  tableCell: { margin: "auto", marginTop: 5, fontSize: 10 },
  myTableCell: { width: '25%', margin: "auto" },
});


export default class PdfDocument extends React.Component {

    static async getAddress (event, investor, breaks, meetings, folder){

        return new Promise(async function (resolve, reject) {

            var filterMeetings = meetings.filter((elem) => Utils.checkInvestor(elem.investors, investor.id));        
            var filterBreaks = breaks.filter((elem) => elem.subject == investor.id);

        var startDate = event.startDate;
        var endDate = event.endDate;

        startDate = moment(startDate, "DD/MM/yyyy");
        endDate = moment(endDate, "DD/MM/yyyy");

        var eventDays = [];
        var tempDate = startDate;
        while (tempDate <= endDate){
            eventDays.push(moment(tempDate));
          tempDate = tempDate.add(1, 'd');
        }

        let days = [];
        eventDays.forEach(v => {
            let date = moment(v).format('DD/MM/yyyy');
            let dateComplete = moment(v).format('dddd, DD MMMM yyyy');
            
            let filterMeetingsDate = filterMeetings.filter((elem) => elem.date == date);
            let filterBreaksDate = filterBreaks.filter((elem) => elem.date == date);
            var infoSchedules = event.brokersInfoSchedulesEnabled;

            let sortMeetings = filterMeetingsDate.sort((a, b) => {
                var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
                var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

                return time1 - time2;
            });

            let sortBreaks = filterBreaksDate.sort((a, b) => {
                var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
                var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

                return time1 - time2;
            });

            var meetings = [];

                Utils.getHoursArray().map(hh => {
                    return Utils.getMinutesArray().map(mm => {

                        var elemToReturn = <View />;
                        sortBreaks.forEach(b => {
                            if (b.break_type == 'Unavailable') return <View />;
                            if (b.minutes != mm || b.hour != hh) return <View />;
                            let breakTime = moment(parseInt(b.hour)+":"+parseInt(b.minutes), "hh:mm");
                            let breakEndTime = moment(breakTime).add(b.slots * 5, 'minutes');

                            let strTime = moment(breakTime).format("HH:mm");
                            let strEndTime = moment(breakEndTime).format("HH:mm");

                            var elem = {
                                "time": strTime + ' - ' + strEndTime,
                                "description": b.break_type,
                                "notes": ""
                            };
                            meetings.push(elem);

                        })

                        sortMeetings.forEach(m => {

                            var notes = m.notes;
                            notes = notes.replace('Click here to join the meeting', '<b>Click here to join the meeting</b>'); 

                            if (m.minutes != mm || m.hour != hh) return <View />;
                            let meetingTime = moment(parseInt(m.hour)+":"+parseInt(m.minutes), "hh:mm");
                            let meetingEndTime = moment(meetingTime).add(m.slots * 5, 'minutes');

                            let strTime = moment(meetingTime).format("HH:mm");
                            let strEndTime = moment(meetingEndTime).format("HH:mm");

                            var companiesList = [];
                            m.investors.sort((a, b) => {
                                var strA = a.company + a.name;
                                var strB = b.company + b.name;                     
                                return strA.localeCompare(strB);
                            }).map(inv => {
                                if (inv.isAnalyst == 0 && companiesList.indexOf(inv.company) == -1)
                                    companiesList.push(inv.company);
                            });

                            var meetingDesc = "";
                            if (companiesList.length == 0) meetingDesc += "Analysts Meeting with: \n";
                            else if (companiesList.length == 1) meetingDesc += "1 to 1 Meeting with: ";
                            else if (companiesList.length < 5) meetingDesc += "1 to Few Meeting with: ";
                            else meetingDesc += "Group Meeting with: ";
                            
                            meetingDesc += '<b>'+m.c_name+'</b>';
                            if (infoSchedules == 1) 
                                meetingDesc += ' (hosted by ' + m.brokerCompany+ ')';

                            const rapresentativeArray = m.rapresentative.split(';');
                            const exceludedRapresentativeArray = m.excludedRapresentatives.split(';');
                            if (rapresentativeArray.length > 0) {
                                meetingDesc+= " - ";
                                rapresentativeArray.map(r => {
                                    if (exceludedRapresentativeArray.indexOf(r) == -1 )
                                        meetingDesc += r + "; ";
                                });
                            }

                            var elem = {
                                "time": strTime + ' - ' + strEndTime,
                                "description": meetingDesc,
                                "notes": notes !== undefined ? notes.trim().replaceAll('<a', '<a style="font-weight: bold; color: #7B83EB;"').replaceAll('<strong>', '<b>').replaceAll('</strong>', '</b>') : ''
                            }

                            meetings.push(elem);
                        }) 

                })
            })

            if (sortMeetings.length > 0)
                days.push({
                    "date": dateComplete,
                    "meetings": meetings,
                });
        });


        var pdfPages = [];
        var pdfJson = { "folder": folder, "fileName": investor.company.replaceAll('/', '_') + ' - ' + investor.name.replaceAll('/', '_') + ' - ' + event.eventName.replaceAll('/', '_'), "documents" : [] };
        var i = 0;
        var count = 0;
        while (i < days.length) {

            var d = days[i];
            if (d.meetings.length <= 0){
                i++;
                continue;
            }
            count++;
            /*var json = {
                "documents": [
                    {
                        "banner": event.bannerImageUrl,
                        "timezone": event.timezoneInformation,
                        "subject": event.eventName + ' - ' + investor.company + ' - ' + investor.name,
                        "footerText": event.notes,
                        "subjectDescription": investor.notes,
                        "days": [d]
                    }
                ]
            };*/

            pdfJson.documents.push({
                "banner": event.bannerImageUrl,
                "timezone": event.timezoneInformation,
                "subject": event.eventName + ' - ' + investor.company + ' - ' + investor.name,
                "footerText": event.notes,
                "subjectDescription": investor.notes,
                "days": [d], 
                "cDay": d,
            });

           // pdfPages.push(fileUrl);

            i++;
        };
        
        var ret = await getPdf('', '', pdfJson);
        resolve(('http://fixmeeting.eu/'+JSON.parse(ret).fileUrl).replace('/var/www/html/', ''));

        /*var fileName = investor.company + ' - ' + investor.name;
        var inputJson = {
            "files" : pdfPages,
            "fileName" : folder +  fileName + ' - ' + event.eventName + ".pdf"
        };
        var retUrl = await mergePdf('', '', inputJson);
        //window.open('http://fixmeeting.eu/'+JSON.parse(retUrl).fileUrl, '_blank');

        resolve('http://fixmeeting.eu/'+JSON.parse(retUrl).fileUrl);*/
    }


    )}
}
